import { render, staticRenderFns } from "./TableroHeader.vue?vue&type=template&id=533713f1&scoped=true"
import script from "./TableroHeader.vue?vue&type=script&lang=js"
export * from "./TableroHeader.vue?vue&type=script&lang=js"
import style0 from "./TableroHeader.vue?vue&type=style&index=0&id=533713f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533713f1",
  null
  
)

export default component.exports